import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function FloatingCTA() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      // Show after scrolling past hero (approx 600px)
      if (latest > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  }, [scrollY]);
  if (!isVisible) return null;
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: 0
  }} exit={{
    y: 100
  }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-[#E2E8F0] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-18">
      <div className="flex items-center justify-between max-w-md mx-auto" data-id="element-19">
        <div className="flex flex-col" data-id="element-20">
          <span className="font-bold text-[#1B2A4A]" data-id="element-21">Reset Familiar</span>
          <span className="text-xs text-[#4A5568]" data-id="element-22">Plan de 7 días</span>
        </div>
        <a href="#pricing" className="px-6 py-3 bg-[#C4704B] text-white font-bold rounded-full text-sm shadow-md" data-id="element-23">
          Quiero el plan
        </a>
      </div>
    </motion.div>;
}